import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, computed, inject } from '@angular/core';
import { BaseFileAction } from '@iris/modules/dms/components/file-actions/base-file-action';
import { IrisDmsModalsSandbox } from '@iris/common/modules/dms/sandbox/dms-modals.sandbox';
import { take, tap } from 'rxjs/operators';
import { IrisDMSTagI } from '@iris/common/modules/dms/models/IrisDMSTag';
import { isEqual } from 'lodash';
import { IrisDmsFilesSandbox } from '@iris/common/modules/dms/sandbox/dms-files.sandbox';
import { NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuItem } from '@angular/material/menu';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-dms-select-tags-button',
  imports: [
    NgClass,

    MatTooltipModule,
    MatMenuItem,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
  templateUrl: './dms-select-tags-button.component.html',
  styleUrls: ['./dms-select-tags-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsSelectTagsButtonComponent extends BaseFileAction {
  private readonly dmsModalSandbox = inject(IrisDmsModalsSandbox);
  private readonly dmsFilesSandbox = inject(IrisDmsFilesSandbox);

  @Input() icon = 'fa-tag';
  @Input() local = false;

  @Input() selectedTags: IrisDMSTagI[] = [];

  readonly label = 'label.dms.AddTags';

  @Output() tagsChanged = new EventEmitter<IrisDMSTagI[]>();

  readonly tagsButtonDisabled = computed(() => {
    return this.local ? this.isFolderLocked() : this.isFileDisabled();
  });

  openSelectTagsModal(): void {
    const { onSuccess$ } = this.dmsModalSandbox.showSelectTagsModal(this.selectedTags);
    onSuccess$.pipe(
      take(1),
      tap((tags: IrisDMSTagI[]) => {
        if (this.local) {
          this.tagsChanged.emit(tags);
        } else if (!isEqual(this.selectedTags.map(tag => tag.id), tags.map(tag => tag.id))) {
          this.dmsFilesSandbox.updateFileTags(this.fileId(), tags);
        }
        this.selectedTags = tags;
      }),
    ).subscribe();
  }
}
